var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row", attrs: { id: "m_sortable_portlets" } }, [
        _c(
          "div",
          { staticClass: "kanban__item-list step-1" },
          [
            _c("h2", [_vm._v("1. Reminder")]),
            _vm._v(" "),
            _vm._l(_vm.offers, function(offer) {
              return offer.reminder_1_level == 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet",
                      class: { "reminder-not-active": !offer.isReminder },
                      attrs: { "data-portlet": "true", id: "m_portlet_tools_1" }
                    },
                    [
                      _c("div", { staticClass: "m-portlet__head pl-0" }, [
                        _c("div", { staticClass: "m-portlet__head-caption" }, [
                          _c("div", { staticClass: "m-portlet__head-title" }, [
                            _c("div", { staticClass: "row pt-1 ml-0 mr-0" }, [
                              _c("div", { staticClass: "col-8" }, [
                                offer.client_id == 0 || offer.is_new_client
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("NEUKUNDE")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--metal m-badge--wide"
                                      },
                                      [_vm._v("STAMM KD")]
                                    ),
                                _vm._v(" "),
                                offer.wait == 1 && offer.status_id === 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("WAIT")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                offer.from_id == 2
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1 m-badge m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("CAPTURE STUDIO")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1  m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("PROFO")]
                                    )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--secondary m-badge--wide"
                                  },
                                  [_vm._v(_vm._s(offer.createdDay))]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__body" }, [
                        _c(
                          "div",
                          { staticClass: "m-card-user m-card-user--sm" },
                          [
                            _c("div", { staticClass: "m-card-user__pic" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-card-user__no-photo m--bg-fill-success",
                                  class:
                                    "m-badge--client-class-" + offer.classId
                                },
                                [_c("span", [_vm._v(_vm._s(offer.className))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-card-user__details" }, [
                              offer.firma != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-card-user__name font-weight-bold",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [
                                      offer.client_id > 0
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              attrs: {
                                                href: "kunde-" + offer.client_id
                                              }
                                            },
                                            [_vm._v(_vm._s(offer.client_id))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" " + _vm._s(offer.firma))
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  offer.client_id > 0 && offer.firma == ""
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: {
                                            href: "kunde-" + offer.client_id
                                          }
                                        },
                                        [_vm._v(_vm._s(offer.client_id))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(offer.name))
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _c("small", [
                                    _c("i", { staticClass: "fa fa-at" }),
                                    _vm._v(" " + _vm._s(offer.email))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              offer.telefon != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(" " + _vm._s(offer.telefon))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      offer.isReminder
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  offer.reminderDays > 3
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--warning m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--secondary m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                ]
                              )
                            ])
                          ])
                        : offer.reminderDate !== "null"
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-badge m-badge--info m-badge--wide"
                                    },
                                    [
                                      _vm._v(
                                        "Reminder für " +
                                          _vm._s(offer.reminderDate) +
                                          " gesetzt"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.price) + " € pro Bild")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v("SUMME " + _vm._s(offer.sum))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.anzahlCa) + " Bilder")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default js-project-portlet__details-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.showDetails(offer)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "Details (" +
                                      _vm._s(offer.updates.length) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "m-portlet m-portlet--sortable-empty status-1"
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "kanban__item-list step-2" },
          [
            _c("h2", [_vm._v("2. Reminder")]),
            _vm._v(" "),
            _vm._l(_vm.offers, function(offer) {
              return offer.reminder_1_level == 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet",
                      class: { "reminder-not-active": !offer.isReminder },
                      attrs: { "data-portlet": "true", id: "m_portlet_tools_2" }
                    },
                    [
                      _c("div", { staticClass: "m-portlet__head pl-0" }, [
                        _c("div", { staticClass: "m-portlet__head-caption" }, [
                          _c("div", { staticClass: "m-portlet__head-title" }, [
                            _c("div", { staticClass: "row pt-1 ml-0 mr-0" }, [
                              _c("div", { staticClass: "col-8" }, [
                                offer.client_id == 0 || offer.is_new_client
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("NEUKUNDE")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--metal m-badge--wide"
                                      },
                                      [_vm._v("STAMM KD")]
                                    ),
                                _vm._v(" "),
                                offer.wait == 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("WAIT")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                offer.from_id == 2
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1 m-badge m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("CAPTURE STUDIO")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1  m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("PROFO")]
                                    )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--secondary m-badge--wide"
                                  },
                                  [_vm._v(_vm._s(offer.createdDay))]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__body" }, [
                        _c(
                          "div",
                          { staticClass: "m-card-user m-card-user--sm" },
                          [
                            _c("div", { staticClass: "m-card-user__pic" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-card-user__no-photo m--bg-fill-success",
                                  class:
                                    "m-badge--client-class-" + offer.classId
                                },
                                [_c("span", [_vm._v(_vm._s(offer.className))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-card-user__details" }, [
                              offer.firma != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-card-user__name font-weight-bold",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [
                                      offer.client_id > 0
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              attrs: {
                                                href: "kunde-" + offer.client_id
                                              }
                                            },
                                            [_vm._v(_vm._s(offer.client_id))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" " + _vm._s(offer.firma))
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  offer.client_id > 0 && offer.firma == ""
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: {
                                            href: "kunde-" + offer.client_id
                                          }
                                        },
                                        [_vm._v(_vm._s(offer.client_id))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(offer.name))
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _c("small", [
                                    _c("i", { staticClass: "fa fa-at" }),
                                    _vm._v(" " + _vm._s(offer.email))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              offer.telefon != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(" " + _vm._s(offer.telefon))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      offer.isReminder
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  offer.reminderDays > 3
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--warning m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--secondary m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                ]
                              )
                            ])
                          ])
                        : offer.reminderDate !== "null"
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-badge m-badge--info m-badge--wide"
                                    },
                                    [
                                      _vm._v(
                                        "Reminder für " +
                                          _vm._s(offer.reminderDate) +
                                          " gesetzt"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.price) + " € pro Bild")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v("SUMME " + _vm._s(offer.sum))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.anzahlCa) + " Bilder")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default js-project-portlet__details-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.showDetails(offer)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "Details (" +
                                      _vm._s(offer.updates.length) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "m-portlet m-portlet--sortable-empty status-2"
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "kanban__item-list step-3" },
          [
            _c("h2", [_vm._v("3. Reminder")]),
            _vm._v(" "),
            _vm._l(_vm.offers, function(offer) {
              return offer.reminder_1_level == 2
                ? _c(
                    "div",
                    {
                      staticClass:
                        "m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet",
                      class: { "reminder-not-active": !offer.isReminder },
                      attrs: { "data-portlet": "true", id: "m_portlet_tools_3" }
                    },
                    [
                      _c("div", { staticClass: "m-portlet__head pl-0" }, [
                        _c("div", { staticClass: "m-portlet__head-caption" }, [
                          _c("div", { staticClass: "m-portlet__head-title" }, [
                            _c("div", { staticClass: "row pt-1 ml-0 mr-0" }, [
                              _c("div", { staticClass: "col-8" }, [
                                offer.client_id == 0 || offer.is_new_client
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("NEUKUNDE")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--metal m-badge--wide"
                                      },
                                      [_vm._v("STAMM KD")]
                                    ),
                                _vm._v(" "),
                                offer.wait == 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("WAIT")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                offer.from_id == 2
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1 m-badge m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("CAPTURE STUDIO")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1  m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("PROFO")]
                                    )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--secondary m-badge--wide"
                                  },
                                  [_vm._v(_vm._s(offer.createdDay))]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__body" }, [
                        _c(
                          "div",
                          { staticClass: "m-card-user m-card-user--sm" },
                          [
                            _c("div", { staticClass: "m-card-user__pic" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-card-user__no-photo m--bg-fill-success",
                                  class:
                                    "m-badge--client-class-" + offer.classId
                                },
                                [_c("span", [_vm._v(_vm._s(offer.className))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-card-user__details" }, [
                              offer.firma != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-card-user__name font-weight-bold",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [
                                      offer.client_id > 0
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              attrs: {
                                                href: "kunde-" + offer.client_id
                                              }
                                            },
                                            [_vm._v(_vm._s(offer.client_id))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" " + _vm._s(offer.firma))
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  offer.client_id > 0 && offer.firma == ""
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: {
                                            href: "kunde-" + offer.client_id
                                          }
                                        },
                                        [_vm._v(_vm._s(offer.client_id))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(offer.name))
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _c("small", [
                                    _c("i", { staticClass: "fa fa-at" }),
                                    _vm._v(" " + _vm._s(offer.email))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              offer.telefon != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(" " + _vm._s(offer.telefon))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      offer.isReminder
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  offer.reminderDays > 3
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--warning m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--secondary m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                ]
                              )
                            ])
                          ])
                        : offer.reminderDate !== "null"
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-badge m-badge--info m-badge--wide"
                                    },
                                    [
                                      _vm._v(
                                        "Reminder für " +
                                          _vm._s(offer.reminderDate) +
                                          " gesetzt"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.price) + " € pro Bild")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v("SUMME " + _vm._s(offer.sum))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.anzahlCa) + " Bilder")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default js-project-portlet__details-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.showDetails(offer)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "Details (" +
                                      _vm._s(offer.updates.length) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "m-portlet m-portlet--sortable-empty status-3"
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "kanban__item-list step-4" },
          [
            _c("h2", [_vm._v("4. Reminder")]),
            _vm._v(" "),
            _vm._l(_vm.offers, function(offer) {
              return offer.reminder_1_level == 3
                ? _c(
                    "div",
                    {
                      staticClass:
                        "m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet",
                      class: { "reminder-not-active": !offer.isReminder },
                      attrs: { "data-portlet": "true", id: "m_portlet_tools_4" }
                    },
                    [
                      _c("div", { staticClass: "m-portlet__head pl-0" }, [
                        _c("div", { staticClass: "m-portlet__head-caption" }, [
                          _c("div", { staticClass: "m-portlet__head-title" }, [
                            _c("div", { staticClass: "row pt-1 ml-0 mr-0" }, [
                              _c("div", { staticClass: "col-8" }, [
                                offer.client_id == 0 || offer.is_new_client
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("NEUKUNDE")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge  m-badge--metal m-badge--wide"
                                      },
                                      [_vm._v("STAMM KD")]
                                    ),
                                _vm._v(" "),
                                offer.wait == 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("WAIT")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                offer.from_id == 2
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1 m-badge m-badge--danger m-badge--wide"
                                      },
                                      [_vm._v("CAPTURE STUDIO")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-1  m-badge m-badge--info m-badge--wide"
                                      },
                                      [_vm._v("PROFO")]
                                    )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4 text-right" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "m-badge  m-badge--secondary m-badge--wide"
                                  },
                                  [_vm._v(_vm._s(offer.createdDay))]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__body" }, [
                        _c(
                          "div",
                          { staticClass: "m-card-user m-card-user--sm" },
                          [
                            _c("div", { staticClass: "m-card-user__pic" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "m-card-user__no-photo m--bg-fill-success",
                                  class:
                                    "m-badge--client-class-" + offer.classId
                                },
                                [_c("span", [_vm._v(_vm._s(offer.className))])]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-card-user__details" }, [
                              offer.firma != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-card-user__name font-weight-bold",
                                      staticStyle: { "max-width": "350px" }
                                    },
                                    [
                                      offer.client_id > 0
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              attrs: {
                                                href: "kunde-" + offer.client_id
                                              }
                                            },
                                            [_vm._v(_vm._s(offer.client_id))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" " + _vm._s(offer.firma))
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  offer.client_id > 0 && offer.firma == ""
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-primary",
                                          attrs: {
                                            href: "kunde-" + offer.client_id
                                          }
                                        },
                                        [_vm._v(_vm._s(offer.client_id))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(offer.name))
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "m-card-user__name",
                                  staticStyle: { "max-width": "350px" }
                                },
                                [
                                  _c("small", [
                                    _c("i", { staticClass: "fa fa-at" }),
                                    _vm._v(" " + _vm._s(offer.email))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              offer.telefon != ""
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "m-card-user__name",
                                      staticStyle: { "white-space": "nowrap" }
                                    },
                                    [
                                      _c("small", [
                                        _c("i", { staticClass: "fa fa-phone" }),
                                        _vm._v(" " + _vm._s(offer.telefon))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      offer.isReminder
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  offer.reminderDays > 3
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--warning m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "m-badge m-badge--secondary m-badge--wide"
                                        },
                                        [
                                          _vm._v(
                                            "Reminder für " +
                                              _vm._s(offer.reminderName) +
                                              " seit " +
                                              _vm._s(offer.reminderDays) +
                                              " Tagen"
                                          )
                                        ]
                                      )
                                ]
                              )
                            ])
                          ])
                        : offer.reminderDate !== "null"
                        ? _c("div", { staticClass: "m-portlet__foot" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 align-items-right text-left"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "m-badge m-badge--info m-badge--wide"
                                    },
                                    [
                                      _vm._v(
                                        "Reminder für " +
                                          _vm._s(offer.reminderDate) +
                                          " gesetzt"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.price) + " € pro Bild")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v("SUMME " + _vm._s(offer.sum))]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__foot" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-left"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "m-badge  m-badge--secondary m-badge--wide"
                                },
                                [_vm._v(_vm._s(offer.anzahlCa) + " Bilder")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 align-items-right text-right"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default js-project-portlet__details-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.showDetails(offer)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "Details (" +
                                      _vm._s(offer.updates.length) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "m-portlet m-portlet--sortable-empty status-4"
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("offer-details", {
        attrs: {
          "detail-offer": _vm.detailOffer,
          user: _vm.user,
          "reminder-type-arr": _vm.reminderTypeArr,
          managers: _vm.managers
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "kanban__item-list step-5" }, [
      _c("h2", [_vm._v("Abschuss Liste")]),
      _vm._v(" "),
      _c("div", { staticClass: "m-portlet m-portlet--sortable-empty status-5" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }